import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function MobileAppDevelopment() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const platforms = [
        "React Native (iOS/Android)",
        "Flutter (Cross-platform)", 
        "Native iOS (Swift)",
        "Native Android (Kotlin/Java)",
        "Progressive Web Apps (PWA)",
        "Ionic Framework",
        "Xamarin",
        "Hybrid app development"
    ];

    const features = [
        "Cross-platform development",
        "Native performance optimization",
        "Push notifications",
        "Offline data synchronization",
        "Geolocation services",
        "Camera & media integration",
        "In-app purchases",
        "Social media integration"
    ];

    const services = [
        "App store optimization (ASO)",
        "Beta testing & QA",
        "App store submission",
        "Performance monitoring",
        "Crash reporting",
        "Analytics integration",
        "A/B testing setup",
        "App maintenance & updates"
    ];

    const integrations = [
        "REST & GraphQL APIs",
        "Firebase services",
        "Payment gateways",
        "Social login (Google, Facebook)",
        "Cloud storage",
        "Real-time databases",
        "Maps & navigation",
        "Third-party SDKs"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Mobile App Development</h1>
                    <p className="service-description">
                        App native e cross-platform per iOS e Android. Sviluppo completo
                        dalla progettazione alla pubblicazione sugli store.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={8}>
                            <div className="service-description">
                                <h3>Sviluppo App Mobile Professionale</h3>
                                <p>
                                    Creo applicazioni mobile moderne e performanti per iOS e Android utilizzando 
                                    le migliori tecnologie cross-platform e native. Dall'idea alla pubblicazione
                                    negli store, gestisco ogni fase dello sviluppo mobile.
                                </p>
                                <p>
                                    Specializzato in React Native, Flutter e sviluppo nativo, garantisco 
                                    performance ottimali, user experience eccellente e integrazione perfetta 
                                    con i servizi backend e API esistenti.
                                </p>
                            </div>

                            <div className="platforms-section">
                                <h3>Piattaforme e Tecnologie</h3>
                                <Row>
                                    {platforms.map((platform, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">📱</span>
                                                {platform}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="features-section">
                                <h3>Funzionalità Mobile</h3>
                                <Row>
                                    {features.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">⚡</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="info" className="mobile-alert">
                                <h5><i className="fas fa-mobile-alt"></i> Cross-Platform Excellence</h5>
                                <p>
                                    Sviluppo app cross-platform con React Native e Flutter per massimizzare
                                    l'efficienza dello sviluppo mantenendo performance native su entrambe le piattaforme.
                                </p>
                            </Alert>

                            <div className="integrations-section">
                                <h3>Integrazioni e Servizi</h3>
                                <Row>
                                    {integrations.map((integration, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🔗</span>
                                                {integration}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="services-section">
                                <h3>Servizi Completi</h3>
                                <Row>
                                    {services.map((service, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🚀</span>
                                                {service}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Processo di Sviluppo</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Discovery, wireframing e design UX/UI</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Sviluppo MVP con funzionalità core</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Testing, ottimizzazione e debug</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Deploy store e monitoring post-launch</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Specializzazioni Mobile</h4>
                                        <ul>
                                            <li>React Native development</li>
                                            <li>Flutter cross-platform</li>
                                            <li>Native iOS (Swift)</li>
                                            <li>Native Android (Kotlin)</li>
                                            <li>Progressive Web Apps</li>
                                            <li>Enterprise mobile solutions</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="stores-card">
                                    <Card.Body>
                                        <h4>📱 App Stores</h4>
                                        <ul>
                                            <li>Apple App Store submission</li>
                                            <li>Google Play Store</li>
                                            <li>App Store Optimization (ASO)</li>
                                            <li>Store guidelines compliance</li>
                                            <li>Beta testing (TestFlight)</li>
                                            <li>Release management</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="analytics-card">
                                    <Card.Body className="text-center">
                                        <h5>📊 Analytics & Monitoring</h5>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>Firebase Analytics</li>
                                            <li>Crashlytics integration</li>
                                            <li>Performance monitoring</li>
                                            <li>User behavior tracking</li>
                                            <li>Custom events</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo Mobile</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
            </Container>
        </div>
    );
}

export default MobileAppDevelopment;